module.exports = __webpack_public_path__ + "img/ic-gear.6766fea6.svg";